// extracted by mini-css-extract-plugin
export var childrenContainer = "_bt-0";
export var virtualScrollArea = "_bt-1";